import { createContext, useContext } from 'react'
import type { AnalysisModeContextValue } from '../types'

const AnalysisModeContext = createContext<AnalysisModeContextValue | undefined>(
  undefined
)

export const AnalysisModeProvider = AnalysisModeContext.Provider

export const useAnalysisMode = (): AnalysisModeContextValue => {
  const context = useContext(AnalysisModeContext)
  if (context === undefined) {
    throw new Error(
      'useAnalysisMode must be used within an AnalysisModeProvider'
    )
  }
  return context
}
